import React from "react";
import Pagination from "src/components/pages/your-campaign/Pagination";
import { useAudience } from "src/contexts/AudienceContext";

export default function YourAudience() {
  const {
    audiences,
    isLoading,
    error,
    fetchAudiences,
    totalCount,
    currentPage,
    setCurrentPage,
    itemsPerPage
  } = useAudience();

  // React.useEffect(() => {
  //   fetchAudiences();
  // }, []);

  // Calculate pagination values
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = audiences.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  // Change page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  // Generate page numbers for pagination
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  // Skeleton loading component
  const SkeletonRow = () => (
    <tr className="border-t animate-pulse">
      {Array.from({ length: 11 }).map((_, i) => (
        <td key={i} className="px-6 py-4">
          <div className="h-4 bg-gray-200 rounded"></div>
        </td>
      ))}
    </tr>
  );
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="relative">
      {/* Header */}
      <div className="flex justify-between items-center pb-6">
        <div>
          <p className="text-[32px] font-semibold text-black font-inter">
            Your Audiences
          </p>
          <p className="text-lg font-inter font-normal text-[#4A4D4F]">
            Compare active and inactive groups by performance.
          </p>
        </div>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="mt-6 overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-lg text-base">
          <thead>
            <tr>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Audience Name
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Location
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Created Date
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Groups
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Status
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                CPM
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                CPC
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Leads
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Purchases
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Hook Rate
              </th>
              <th className="px-6 py-4 text-left font-semibold text-grayscale-700 text-base">
                Hold Rate
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              // Show skeleton loading when data is being fetched
              Array.from({ length: itemsPerPage }).map((_, index) => (
                <SkeletonRow key={index} />
              ))
            ) : (
              // Show actual data when loaded
              currentItems.map((row, i) => (
                <tr
                  key={i}
                  className="border-t hover:bg-gray-50 transition"
                >
                  <td className="px-6 py-4">{row.audience || "N/A"}</td>
                  <td className="px-6 py-4">{row.location || "N/A"}</td>
                  <td className="px-6 py-4">{row.date || "N/A"}</td>
                  <td className="px-6 py-4">{row.group || "N/A"}</td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-4 py-2 rounded-full text-sm font-medium ${row.status === "ACTIVE" || row.status === "Active"
                        ? "bg-green-100 text-green-700"
                        : "bg-gray-200 text-gray-700"
                        }`}
                    >
                      {row.status || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4">{row.cpm || "$0.00"}</td>
                  <td className="px-6 py-4">{row.cpc || "$0.00"}</td>
                  <td className="px-6 py-4">{row.leads || "0"}</td>
                  <td className="px-6 py-4">{row.purchases || "0"}</td>
                  <td className="px-6 py-4">{row.hook || "0.00%"}</td>
                  <td className="px-6 py-4">{row.hold || "0.00%"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        {!isLoading && audiences.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalItems={audiences.length}
            pageSize={totalPages}
            onPageChange={handlePageChange}
          />
        )}

        {/* Empty state */}
        {!isLoading && audiences.length === 0 && !error && (
          <div className="text-center py-8 text-gray-500">
            No audience data available.
          </div>
        )}
      </div>
    </div>
  );
}